
<div class="bottom-sheet">
    <div> {{data.tasks.length}} {{ 'tasks' | translate }} {{ 'have the same content link.' | translate }} </div>
    <button mat-raised-button type="button" #btnFocus cdkFocusInitial color="warn" (click)="close()">{{ "Close" | translate }}</button>
    <button mat-raised-button class="change" type="submit" color="primary" (click)="continue()">{{ "Show" | translate }}</button>
</div>